import { REMOVE_RELATED_THUMBNAIL } from "../reducers/actiontypes";

const initialState = (function(state){
	return state || {};
})(window.commentstate.media);

export default function(state=initialState, action) {
	switch (action.type) {
		case REMOVE_RELATED_THUMBNAIL:
			switch (action.index) {
				case "next":
					return {
						...state,
						related: {
							...state.related,
							next: {
								...state.related.next,
								thumbnail:""
							}
						}
					};
				case "previous":
					return {
						...state,
						related: {
							...state.related,
							previous: {
								...state.related.previous,
								thumbnail:""
							}
						}
					};
				default:
					return {
						...state,
						related: {
							...state.related,
							items: [
								...state.related.items.slice(0, action.index),
								{
									...state.related.items[action.index],
									thumbnail: ""
								},
								...state.related.items.slice(action.index+1)
							]
						}
					};
			}
		default:
			return state;
	}
}